var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 22.668C7.65685 22.668 9 21.3248 9 19.668C9 18.0111 7.65685 16.668 6 16.668C4.34315 16.668 3 18.0111 3 19.668C3 21.3248 4.34315 22.668 6 22.668Z",
    stroke: "#345C72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.668H17.5C18.4283 19.668 19.3185 19.2992 19.9749 18.6428C20.6313 17.9865 21 17.0962 21 16.168C21 15.2397 20.6313 14.3495 19.9749 13.6931C19.3185 13.0367 18.4283 12.668 17.5 12.668H6.5C5.57174 12.668 4.6815 12.2992 4.02513 11.6428C3.36875 10.9865 3 10.0962 3 9.16797C3 8.23971 3.36875 7.34947 4.02513 6.6931C4.6815 6.03672 5.57174 5.66797 6.5 5.66797H15",
    stroke: "#345C72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.66797C19.6569 8.66797 21 7.32482 21 5.66797C21 4.01111 19.6569 2.66797 18 2.66797C16.3431 2.66797 15 4.01111 15 5.66797C15 7.32482 16.3431 8.66797 18 8.66797Z",
    stroke: "#345C72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.b5ece7b0a749bcc5c9b5983cfc65a19a.svg";
export { ForwardRef as ReactComponent };